import {useMutation} from "@tanstack/react-query";

import {addLeadNoteMutationOptions} from "./add-lead-note.mutation-options";

export function useAddLeadNote(leadId: string) {
  return useMutation(addLeadNoteMutationOptions(leadId));
}
